import * as yup from 'yup';

export const createAccountByEmailSchema = yup.object().shape({
  email: yup.string().required().email(),
});
